export default "__VITE_ASSET__BfKC8cSv__"